// test2476
(2476 && 0);
